// ============================================================================
// DropdownList.jsx — Corelia v1.2 (FormLayout + thème unifié 100% form)
// ============================================================================
import React, { useState, useEffect, useRef } from "react";
import theme from "../../../styles/theme";
import "../../../styles/main.css";
import FormLayout from "./FormLayout";

const ChevronUp = "/assets/icones/chevron-up.svg";

const DropdownList = ({
  label,
  required = false,
  labelPosition = "left",
  labelWidth = null,
  align = "center",
  options = [],
  value,
  onChange,
  placeholder = "Sélectionner...",
  disabled = false,
  style = {},
  onOpen,
  onClose,
  colorCategory,
  width,
  inputMinHeight,

  // NOUVEAU — permet de régler le wrapper interne sans impacter les autres usages
  wrapperMarginTop = 8,
  wrapperMarginLeft = 8,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);

  useEffect(() => {
    if (open && onOpen) onOpen();
    if (!open && onClose) onClose();
  }, [open]);

  const handleSelect = (optValue) => {
    if (disabled) return;
    onChange(optValue);
    setOpen(false);
  };

  const selectedOpt = options.find((o) => o.value === value);
  const hasValidValue = !!selectedOpt;
  const selectedLabel = hasValidValue ? selectedOpt.label : placeholder;

  const colorMap =
    typeof colorCategory === "object"
      ? colorCategory
      : theme.statusColors?.[colorCategory] ?? null;

  return (
    <FormLayout
      label={
        <>
          {label}
          {required && (
            <span style={{ color: theme.colors.text.required, marginLeft: 4 }}>
              *
            </span>
          )}
        </>
      }
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      align={align}
      width={width}
      style={style}
    >
      <div
        ref={wrapperRef}
        style={{
          position: "relative",
          width: "100%",
          marginTop: wrapperMarginTop,
          marginLeft: wrapperMarginLeft,
        }}
      >
        {/* Champ principal */}
        <div
          onClick={() => !disabled && setOpen(!open)}
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",

            padding: `${theme.form.field.paddingV}px ${theme.form.field.paddingH}px`,
            minHeight: inputMinHeight || theme.form.field.minHeight,

            borderRadius: theme.form.field.borderRadius,
            border: theme.form.field.border,
            backgroundColor: disabled
              ? theme.form.disabled.background
              : theme.form.field.background,
            cursor: disabled ? "not-allowed" : "pointer",

            boxSizing: "border-box",
            transition: theme.form.field.transition,
          }}
        >
          <span
            style={{
              fontFamily: theme.form.label.fontFamily,
              fontSize: theme.form.label.fontSize,
              fontWeight: theme.form.label.fontWeight,
              color:
                !hasValidValue
                  ? theme.form.placeholder
                  : colorCategory && colorMap?.[value]?.label
                  ? colorMap[value].label
                  : theme.form.field.color,
              fontStyle: !hasValidValue ? "italic" : "normal",
            }}
          >
            {selectedLabel}
          </span>

          <img
            src={ChevronUp}
            alt="chevron"
            style={{
              width: 14,
              height: 14,
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
              opacity: disabled ? 0.4 : 0.8,
            }}
          />
        </div>

        {/* Liste déroulante */}
        {open && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              marginTop: 2,

              maxHeight: 220,
              overflowY: "auto",

              border: theme.form.field.border,
              borderRadius: theme.form.field.borderRadius,
              backgroundColor: theme.form.field.background,

              zIndex: 9999,
              boxShadow: theme.form.shadows.xs,
            }}
          >
            {options.map((opt) => {
              const textColor =
                colorMap && colorMap[opt.value]
                  ? colorMap[opt.value].label || colorMap[opt.value].text
                  : theme.form.field.color;

              return (
                <div
                  key={opt.value}
                  onClick={() => handleSelect(opt.value)}
                  style={{
                    padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
                    cursor: "pointer",

                    fontFamily: theme.form.label.fontFamily,
                    fontSize: theme.form.label.fontSize,
                    fontWeight: theme.form.label.fontWeight,
                    color: textColor,

                    backgroundColor:
                      value === opt.value
                        ? theme.colors.background.muted
                        : "transparent",
                    transition: "background-color 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      theme.colors.background.muted)
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      value === opt.value
                        ? theme.colors.background.muted
                        : "transparent")
                  }
                >
                  {opt.label}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </FormLayout>
  );
};

export default DropdownList;